import React from 'react';
import { useTranslation } from 'react-i18next';

const DreamBig: React.FC = () => {
  const { t } = useTranslation();

  const ideas = [
    {
      id: 1,
      image: '/images/energy market.jpg',
      title: t('dreamBig.idea1.title'),
      description: t('dreamBig.idea1.description')
    },
    {
      id: 2,
      image: '/images/power grid.jpg',
      title: t('dreamBig.idea2.title'),
      description: t('dreamBig.idea2.description')
    },
    {
      id: 3,
      image: '/images/grid operation.jpg',
      title: t('dreamBig.idea3.title'),
      description: t('dreamBig.idea3.description')
    }
  ];

  return (
    <section id="dream-big" className="dream-big-section">
      <div className="dream-big-container">
        <h2 className="dream-big-title">{t('dreamBig.title')}</h2>
        <p className="dream-big-subtitle">{t('dreamBig.subtitle')}</p>
        <div className="dream-big-cards">
          {ideas.map((idea) => (
            <div key={idea.id} className="dream-big-card">
              <div className="dream-big-card-image">
                <img src={idea.image} alt={idea.title} />
              </div>
              <div className="dream-big-card-content">
                <h3 className="dream-big-card-title">{idea.title}</h3>
                <p className="dream-big-card-description">{idea.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DreamBig;
